import { Resource, PodcastListeningTimeRelationResponseCollection } from '@edwin-group/cj-graphql';

export default function isPodcastDone(podcast: Resource) {
  const userListed =
    ((podcast?.attributes?.listenings as unknown as PodcastListeningTimeRelationResponseCollection)?.data?.length ||
      0) > 0;
  if (!userListed) {
    return { progress: 0, isDone: false };
  }

  const linsteningTime = (podcast?.attributes?.listenings as unknown as PodcastListeningTimeRelationResponseCollection)
    ?.data?.[0]?.attributes;
  const progress = Math.ceil((linsteningTime?.listeningTime / linsteningTime?.duration) * 100);
  const isDone = progress >= 90;

  return { progress, isDone };
}
